import type { StyleRule } from '@archipro-design/aria';
import { pxToRem } from '@archipro-design/aria';

export const ClickAndCollect: StyleRule = ({ theme }) => ({
    letterSpacing: theme.siteVariables.letterSpacingNormal,
    lineHeight: theme.siteVariables.lineHeightDefault,
    marginTop: pxToRem(4),
    [theme.screen.tablet]: {
        marginTop: theme.siteVariables.spaces['space-8'],
    },
});
